import {RichText} from '@gongxigames/framework/core';

RichText.setStyle('koalaBigWinValue', {
    fontFamily: 'ERASBD',
    fontSize: 360,
    fill: '#FFF696',

    dropShadow: true,
    dropShadowAlpha: 0.6,
    dropShadowBlur: 9,
    dropShadowColor: '#fff600',
    dropShadowDistance: 0
});